import TrackingService from '../services/tracking.service';
import {
  TRACKING_EVENT_ACTION,
  TRACKING_EVENT_CATEGORY,
  TRACKING_EVENT_LABEL,
  TRACKING_EVENT_NAME,
} from '../models/constants';
import { EventTrackingInfo } from '../models/entities/tracking.model';

interface ISlotSelectionBoxComposable {
  trackCalendar: (label: TRACKING_EVENT_LABEL) => void;
}

const useSlotSelectionBox = (): ISlotSelectionBoxComposable => {
  const eventHasBeenCalled = {
    [TRACKING_EVENT_LABEL.CALENDAR_SELECT_DATE]: false,
    [TRACKING_EVENT_LABEL.CALENDAR_SELECT_TIME]: false,
    [TRACKING_EVENT_LABEL.CALENDAR_APPLY]: false,
  };

  const trackCalendar = (label: TRACKING_EVENT_LABEL) => {
    if (eventHasBeenCalled[label]) return;
    eventHasBeenCalled[label] = true;
    const event: EventTrackingInfo = {
      category: TRACKING_EVENT_CATEGORY.FEATURE,
      action: TRACKING_EVENT_ACTION.CALENDAR_REQUEST,
      name: TRACKING_EVENT_NAME.SELECT_TIMESLOT,
      label,
    };
    TrackingService.trackEvent(event);
  };

  return {
    trackCalendar,
  };
};

export { useSlotSelectionBox };
